// removed by extract-text-webpack-plugin
module.exports = {"description":"StyledSelect__description___1YLS5"};